export const USER_PROPERTY__EMAIL = 'email';
export const USER_PROPERTY__NAME = 'name';
export const USER_PROPERTY__PHONE = 'phone';
export const USER_PROPERTY__PICTURE = 'picture';
